import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18nPlugin from './i18n'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'animate.css/animate.min.css'
import 'swiper/dist/css/swiper.min.css'
import './assets/css/main.css'

Vue.config.productionTip = false

Vue.use(i18nPlugin)

new Vue({
  router,
  store,
  render: h => h(App),
  // 预渲染(prerender-spa-plugin)据此事件判定页面已渲染完成再抓取快照
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
